module.exports = __webpack_public_path__ + "img/oma.da96e6eb.png";